// it's a copypaste from the same hook in shared footer component
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { THEMES } from '../constants';
const useThemeAccent = () => {
    const theme = useTheme();
    const themeType = useMemo(() => {
        const type = (theme.type || '').toLocaleLowerCase() || THEMES.UNKNOWN;
        // Unknown type may be returned from the server, so we need to handle it
        // on par with possibility of undefined (line 11)
        if (type === THEMES.UNKNOWN) {
            return THEMES.LIGHT;
        }
        return type;
    }, [theme.type]);
    return themeType;
};
export default useThemeAccent;
